import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import eggshell from '../assets/eggshell.png';
import logo from '../assets/logo.png';
import speedometer from '../assets/speedometer.png';
import report_snippet from '../assets/report_snippet.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { Menu, MenuItem } from '@mui/material';

export default function LandingPage() {

    const notifyMessageSent = (msg) => toast.success(<p>{msg}</p>, {
        toastId: 'messageSent',
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
    });

    function sendEmail(e) {
        e.preventDefault();

        emailjs.sendForm("service_yj69lqb", 'eggshell_contact_form', e.target, "JN_JwlFXMsr9Xk_-9")
            .then((result) => {
                console.log("Message sent.");
            }, (error) => {
                console.log(error.text);
                alert("Sign up failed. Please try again later.");
            }).finally(
                notifyMessageSent("Message sent successfully.")
            );
    }

    const styles = {
        container: {
            backgroundImage: `url(${eggshell})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            width: '100vw',
            height: '100vh',
        }
    };

    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const isMobile = width <= 768;

    const interests = ["Regional Market Comparisons", "Local Market Comparisons", "National Market Comparisons", "Total Reimbursement Analysis", "CPT Code Analysis", "Specialty Specific Analysis", "Specific 3rd Party Payor (indicate)", "Other"]
    const [interest, setInterest] = useState(interests[0]);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSetInterest = (newInterest) => {
        setAnchorEl(null);
        setInterest(newInterest);
    }

    return (
        <div>

            <div className={window.location.href === "http://eggshelliq.com/" || window.location.href.includes('localhost:3000') ? `flex justify-center items-center` : 'hidden'}>
                <div className='fixed bottom-0 mb-16 shadow shadow-gray rounded-xl' style={{zIndex: 5000}}>
                    <a
                        href="#contact"
                        className='text-center w-80 px-5 hover:no-underline py-3 bg-eggshell-green hover:bg-dark-eggshell-green cursor-pointer text-2xl font-bold rounded-xl text-white'
                    >
                        Contact us
                    </a>
                </div>
            </div>

            <div id="top" className={`lg:flex lg:justify-center bg-light-gray ${isMobile ? '-mt-48' : '-mt-36'}`}>
                <div className='flex justify-center items-center' style={styles.container}>
                    <div>
                        <div className='flex justify-center mb-5'>
                            <img src={logo} alt="logo" className='lg:w-40 w-36 rounded-xl' />
                        </div>
                        <div className='flex justify-center tracking-tight font-landingSans'>
                            <p className='lg:text-7xl text-5xl font-black text-center leading-tight tracking-tighter header-width'><span className='text-eggshell-green'>Cracking open </span>healthcare data</p>  
                        </div>
                        <div className='flex justify-center mt-4'>
                            <p className='lg:w-7/12 lg:my-8 place-self-center text-2xl mx-3 text-center'>Helping your medical practice flourish by providing competitive market data on your reimbursement rates.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='py-24 bg-light-gray' id='services'>
                <div className={isMobile ? 'mx-3' : 'mx-5'}>
                    <p className='flex justify-center text-5xl tracking-tighter font-extrabold'>How we can help your practice</p>
                    <div className='flex justify-center text-2xl text-gray mt-20 mb-32'>
                        <p className='max-w-[1000px]'>
                            Tens of thousands of dollars, or more, of potential revenue is left on the table when Physicians and Practices fail to negotiate with their payors. 
                            Even a small improvement in the negotiated rate of some of the most utilized billing codes can result in an enduring and scalable increase in clinic 
                            revenue. Historically, data about rates contracted to providers has been obscure and hidden. However, with the enactment of the
                            <a href="https://www.cms.gov/healthplan-price-transparency" target="__blank" className='ml-1.5 underline'>Health Care Information Transparency Act</a> the rates paid by
                            insurance companies can now be leveraged to strengthen your negotiating position.
                        </p>
                    </div>
                    <div className='mt-24 lg:flex lg:justify-center lg:items-center lg:gap-24 lg:h-80 mb-16'>
                        <div className={isMobile ? 'hidden' : 'lg:flex lg:justify-center mb-5'}>
                            <img src={report_snippet} alt="healthcare data" className='h-80 rounded-xl' />
                        </div>
                        <div className='my-3'>
                            <p className='text-4xl tracking-tighter font-extrabold'>Analysis Reports</p>
                            <p className={`text-2xl text-dark-gray mt-5 ${isMobile ? 'w-auto' : 'w-[470px]'}`}>Knowing your market will assist rate negotiations with your payors potentially <b>increasing clinic revenue</b>.</p>
                        </div>
                        <div className={isMobile ? 'lg:flex lg:justify-center mb-5' : 'hidden'}>
                            <img src={report_snippet} alt="healthcare data" className='h-72 rounded-xl' />
                        </div>
                    </div>
                    <div className='lg:flex lg:justify-center lg:items-center lg:gap-24 lg:h-80'>
                        <div className='my-3'>
                        <p className='text-4xl tracking-tighter font-extrabold'>Know your position</p>
                        <p className={`text-2xl text-dark-gray mt-5 ${isMobile ? 'w-auto' : 'w-[470px]'}`}>Understanding your market position can guide your <b>negotiation strategy</b>.</p>
                        </div>
                        <div className='lg:flex lg:justify-center mb-5'>
                            <img src={speedometer} alt="healthcare worker" className='rounded-xl h-80' />
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className='py-24' id='team'>
                <p className='flex justify-center text-5xl tracking-tighter font-extrabold'>Meet the Team</p>
                <div className='lg:flex justify-center gap-32 mt-16 mx-5'>
                <div>
                    <div className='flex justify-center mt-5'>
                    <img src={scott} alt="scott peterson" className='rounded-xl h-80' />
                    </div>
                    <div className='flex justify-center'>
                    <p className='text-2xl text-dark-gray text-center mt-5' style={{width: '500px'}}>Scott Peterson has extensive experience in the healthcare industry.</p>
                    </div>
                </div>
                </div>
            </div> */}

            <div className='lg:px-5 bg-light-gray' id="contact">
                <div className='flex justify-center mx-2'>
                    <div className='lg:m-5 lg:px-5 py-5 bg-light-gray rounded-xl'>
                        <form className='text-center p-5' onSubmit={() => sendEmail()}>
                            <p className='flex justify-center text-5xl font-extrabold tracking-tighter'>Contact us</p>
                            <div className='flex justify-center'>
                                <p className='w-contact-description text-xl text-gray font-medium mt-8'>
                                To help us begin your market reimbursement analysis, please provide your practice information below.
                                </p>
                            </div>
                            <div className='lg:flex lg:justify-center mt-8 mx-2'>
                                <input placeholder='First Name' type="text" name="first_name" className='h-14 rounded-md border-light-gray-3 border-2 px-3 mt-3 lg:mr-3' style={{width: isMobile ? '300px' : '300px'}} />
                                <input placeholder='Last Name' type="text" name="last_name" className='h-14 rounded-md border-light-gray-3 border-2 px-3 mt-3 lg:mr-3' style={{width: isMobile ? '300px' : '300px'}} />
                            </div>
                            <div className='flex flex-col justify-center items-center'>
                                <input placeholder='Address Line 1' type="text" name="address_line_one" className='h-14 rounded-md border-light-gray-3 border-2 px-3 mt-3 lg:mr-3' style={{width: isMobile ? '300px' : '610px'}} />
                                <input placeholder='Address Line 2' type="text" name="address_line_two" className='h-14 rounded-md border-light-gray-3 border-2 px-3 mt-3 lg:mr-3' style={{width: isMobile ? '300px' : '610px'}} />
                                <input placeholder='Address Line 3' type="text" name="address_line_three" className='h-14 rounded-md border-light-gray-3 border-2 px-3 mt-3 lg:mr-3' style={{width: isMobile ? '300px' : '610px'}} />
                            </div>
                            <div className='lg:flex lg:justify-center lg:gap-2 lg:-ml-2.5'>
                                <input placeholder='City' type="text" name="city" className='h-14 rounded-md border-light-gray-3 border-2 px-3 mt-3' style={{width: isMobile ? '300px' : '245px'}} />
                                <input placeholder='State' type="text" name="state" className='h-14 rounded-md border-light-gray-3 border-2 px-3 mt-3' style={{width: isMobile ? '300px' : '200px'}} />
                                <input placeholder='ZIP' type="text" name="zip" className='h-14 rounded-md border-light-gray-3 border-2 px-3 mt-3' style={{width: isMobile ? '300px' : '150px'}} />
                            </div>
                            <div className='lg:flex lg:justify-center mx-2'>
                                <input placeholder='Email' type="text" name="email" className='h-14 rounded-md border-light-gray-3 border-2 px-3 mt-3 lg:mr-2.5' style={{width: isMobile ? '300px' : '300px'}} />
                                <input placeholder='Specialty' type="text" name="specialty" className='h-14 rounded-md border-light-gray-3 border-2 px-3 mt-3 lg:mr-2.5' style={{width: isMobile ? '300px' : '300px'}} />
                            </div>
                            <div className='lg:flex lg:justify-center mx-2'>
                                <div className='lg:flex lg:justify-center lg:items-center text-lg mt-3'>
                                    <p>I'm interested in:</p>
                                    <p
                                        id="demo-positioned-button"
                                        aria-haspopup="true"
                                        onClick={handleClick}
                                        className={`${isMobile ? 'px-1.5' : 'px-2.5'} py-1.5 ml-1 text-lg rounded-md hover:bg-light-gray-2 cursor-pointer text-black font-semi-bold`}
                                    >
                                        <span>
                                            {interest}
                                            <FontAwesomeIcon icon={faAngleDown} className="text-md ml-2 text-dark-gray" />
                                        </span>
                                    </p>
                                </div>
                                <Menu
                                    id="demo-positioned-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={() => handleClose()}
                                    onBlur={() => handleClose()}
                                    className='mt-1.5 ml-1.5 text-lg'
                                >
                                    {/* <MenuItem key='personal' sx={{fontSize: isMobile ? '15px' : '17px', width: '180px'}} onClick={() => handleSetClientFirst(personal)}>Personal</MenuItem> */}
                                    {interests.map(function (interestOption, index) {
                                        return (
                                            <MenuItem key={`key-${index}`} sx={{ fontSize: isMobile ? '15px' : '17px' }} onClick={() => handleSetInterest(interestOption)}>{interestOption}</MenuItem>
                                        )
                                    })}
                                </Menu>
                            </div>
                            <div className={interest === 'Other' ? 'lg:flex lg:justify-center' : 'hidden'}>
                                <textarea placeholder='Please explain your interest here...' type="text" name="message" className='h-24 lg:w-2/3 w-64 pt-2 rounded-md border-light-gray-3 border-2 px-3 mt-3 lg:mr-3 md:mr-3' style={{width: isMobile ? '100%' : '610px'}} />
                            </div>
                            <div className='lg:flex lg:justify-center mt-5'>
                                <Button
                                    type='submit'
                                    variant='primary-secondary'
                                    className='bg-eggshell-green text-xl hover:bg-eggshell-dark-green mt-3 h-14 w-64 rounded-md px-3 lg:mr-3 py-2'
                                    style={{color: 'white'}}
                                >
                                    Submit
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <hr className='border-gray' />
            <div className='text-center lg:mx-96'>
                <div className='lg:flex lg:justify-around pt-16 pb-12'>
                <div className='flex justify-center mb-5 mt-5'>
                    <img src={logo} alt="logo" className='h-36 rounded-xl' />
                </div>
                <div className='text-gray my-10'>
                    <p className='font-bold mb-3'>Quick Links</p>
                    <a href='#top' className='hover:text-eggshell-green hover:no-underline'>
                    <p className='mb-3'>Home</p>
                    </a>
                    <a href='#contact' className='hover:text-eggshell-green hover:no-underline'>
                    <p className='mb-3'>Contact</p>
                    </a>
                </div>
                </div>
                <div className='flex justify-center mx-5 pb-2 text-gray'>
                <p>© 2022 Eggshell, LLC. All rights reserved.</p>
                </div>
            </div>
        </div>
    )
}
